module.exports = __webpack_public_path__ + "img/video.e6cf7a3c.png";